var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_vm._m(0),_vm._m(1),_c('router-view'),_vm._m(2)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"banner"},[_c('img',{attrs:{"src":require("@/assets/img/banner.png"),"alt":"banner"}})])
},function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"topTitle"},[_c('h2',[_vm._v("快捷服务系统")]),_c('p',[_vm._v("Quick Service")])])
},function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer"},[_c('img',{attrs:{"src":require("@/assets/img/footer.png"),"alt":""}})])
}]

export { render, staticRenderFns }